<template>
  <div class="snackHeader">
    <ur-snackbar
      ref="stackableSnackbar"
      stackable
      @closed="removeMessage"
      closeBtn
      :duration="getSnackbar.duration"
    ></ur-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "snackbarloader",
  computed: {
    ...mapGetters(["getSnackbar"]),
  },
  methods: {
    ...mapActions(["setSnackbar"]),
    removeMessage() {
      this.setSnackbar({
        active: false,
        duration: 2000,
        msg: "",
        stackable: false,
      });
    },
  },
  watch: {
    getSnackbar: {
      handler(newVal) {
        if (newVal.active) {
          // this.$refs.stackableSnackbar.duration = newVal.duration;
          this.$refs.stackableSnackbar.show({ text: newVal.msg });
        }
      },
      deep: true,
    },
  },
};
</script>

<style></style>
